// extracted by mini-css-extract-plugin
module.exports = {"root":"UserNav_root__19vzU","tab":"UserNav_tab__3e18I"};